import { DOM_NODE_SELECTOR_NAVIGATOR } from './utils/consts';

export const getDOMNodeInNavigatorWithDataId = (domNode: Element) => {
  const target = domNode && domNode.closest(DOM_NODE_SELECTOR_NAVIGATOR);
  return target ? target.getAttribute('data-id') : '';
};
